/** Canales para consultas de datos personales y privacidad del portal. */
export const DATA_PROTECTION_EMAIL = 'gerencia@coonaltragas.com';

/** Sede para notificaciones físicas relacionadas con Habeas Data (ajustar dirección si aplica). */
export const DATA_PROTECTION_ADDRESS = 'Cra. 58 #5C - 25 Bogotá, D.C., Colombia';
